import { Dayjs } from 'shared/dayjs'
import { Flex } from 'front-end/src/components'
import { fontSizes, radii } from 'front-end/src/components/chakraThemeExtension'
import React from 'react'
import { brandColors } from 'shared/basicPalette'
import { BoxProps } from '@chakra-ui/react'

const DateIcon = ({
  date,
  dataTest = 'DateIcon',
  ...rest
}: BoxProps & { date: Dayjs; dataTest?: string }) => {
  return (
    <Flex
      direction="column"
      alignItems="center"
      boxSize="56px"
      borderRadius={radii.lg}
      color={brandColors.black}
      bg={brandColors.grey[50]}
      overflow="hidden"
      data-test={dataTest}
      {...rest}
    >
      <Flex
        w="100%"
        h="20px"
        justifyContent="center"
        alignItems="center"
        fontSize={fontSizes.ssm}
        bg={brandColors.grey[100]}
      >
        {date.isValid() && date.format('MMM')}
      </Flex>
      <Flex fontSize={fontSizes['2xl']} grow={1} alignItems="center">
        {date.isValid() && date.format('D')}
      </Flex>
    </Flex>
  )
}

export default DateIcon
